import { render, staticRenderFns } from "./ReactAppHost.vue?vue&type=template&id=3023c6e2&scoped=true"
import script from "./ReactAppHost.vue?vue&type=script&lang=js"
export * from "./ReactAppHost.vue?vue&type=script&lang=js"
import style0 from "./ReactAppHost.vue?vue&type=style&index=0&id=3023c6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023c6e2",
  null
  
)

export default component.exports